export default __webpack_public_path__ + "static/media/Borris_weapon.0967ea3d.png";